export default {"src":"/_next/static/media/plus.3cd53166.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};